const SYNTHETIC_MONITOR_PARAM = 'synthetic_monitor';

function isSyntheticMonitor(
  search: string = globalThis.location.search
): boolean {
  return new URLSearchParams(search).get(SYNTHETIC_MONITOR_PARAM) === 'true';
}

function appendSyntheticMonitorParam(url: string): string {
  if (!isSyntheticMonitor()) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${SYNTHETIC_MONITOR_PARAM}=true`;
}

export { isSyntheticMonitor, appendSyntheticMonitorParam };
